import { render, staticRenderFns } from "./LikeSection.vue?vue&type=template&id=63ba803c&scoped=true&"
import script from "./LikeSection.vue?vue&type=script&lang=js&"
export * from "./LikeSection.vue?vue&type=script&lang=js&"
import style0 from "./LikeSection.vue?vue&type=style&index=0&id=63ba803c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba803c",
  null
  
)

export default component.exports